import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

document.title = "ClaroDesk";
new MutationObserver(() => { if (document.title !== "ClaroDesk") document.title = "ClaroDesk"; })
  .observe(document.querySelector("title"), { childList: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
